var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail"},[(_vm.type === 1 || _vm.type === 3)?_c('course',{key:_vm.id,ref:"course",attrs:{"id":_vm.id}}):_c('exam',{key:_vm.id,ref:"exam",attrs:{"id":_vm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }